import Link from './Link';
import { LinkVariants } from './Link';

export { LinkVariants };
export default Link;